
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/resources/state-tax-guide",
      function () {
        return require("private-next-pages/compliance/resources/state-tax-guide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/resources/state-tax-guide"])
      });
    }
  